/* @jsxImportSource react */

import { type ReactNode } from 'react';
import { cn } from '@packages/shared/src/utils/cn/cn';

export interface ProductCardV2EfficiencyFlagsContainerProps {
  children?: ReactNode;
  className?: string;
}

export const ProductCardV2EfficiencyFlagsContainer = ({
  children,
  className,
}: ProductCardV2EfficiencyFlagsContainerProps) => (
  <div
    className={cn(
      'product-card-efficiency-flags relative z-10',
      '[grid-area:12/2/span_1/span_1]',
      'border-color-grey mt-1 flex flex-col gap-1 border-t px-0.5 py-1 lg:px-1',
      className,
    )}
  >
    {children}
  </div>
);
